
export default 
{
    menu: {
        quemSomos: 'QUEM SOMOS',
        ondeAtuamos: 'ONDE ATUAMOS',
        faleConosco: 'FALE CONOSCO',
        produtos:'PRODUTOS'
    },
    quemSomos: {
        text1: `A JAD Aplicativos  nasceu em Janeiro de 2019 com objetivo de auxiliar
                 de forma rápida e prática a criação e manutenção de projetos de 
                 software  no Brasil e no exterior.`,
        text2: `Sempre com o objetivo de oferecer soluções inovadoras e que respondam as
                necessidades operacionais e produtivas em produtos e serviços escaláveis,
                A JAD Aplicativos foi estruturada a partir da experiência de vários projetos e 
                empresas de Tecnologia e focada nas melhores práticas.`,
        text3: `Com corpo profissional Sênior, todos com mais de 10 anos de experiência,certificados
                e com mais de 30 anos de idade.`,
        text4: `Atuamos em duas frentes: suporte total ao desenvolvedor e ao profissional funcional,
                corrigindo erros, sugerindo implementações, e desenvolvemos aplicações customizadas
                de acordo com o seu negócio,e-commerce, erp's,arquitetura de sistemas,páginas de vendas e landing pages,
                web scraping,automações,scripts, chatbots, NFE, E-social,etc. 
                Além disso oferecemos cursos diversos
                com orçamento abaixo do mercado, pois o nosso foco é sua especialização. Os cursos vão desde
                linguagens de programação, lógica até cursos funcionais, operacionais para ERP's.`
                ,
    },
    ondeAtuamos: {
        text1: `Aqui segue uma breve apresentação de nossos serviços, todos com garantia:`,
        produtos : [
            {nome : 'JADS SUPORTE', valor: `Primeira empresa on line a nivel global especialmente pensada para o suporte ao profissional e correção de bugs.`},
            {nome : 'IMPLEMENTAÇÃO', valor: `Instalamos e configuramos do zero suas aplicações,SAP S/4 HANA,JAVA,.NET,REACT NATIVE, FLUTTER,BD'S.`},
            {nome : 'E-COMMERCE', valor: `Plataforma de serviços para criação de lojas virtuais.`},
            {nome : 'DESENVOLVIMENTO', valor: `Desenvolvemos qualquer tipo de aplicativo seja móvel, web,vendas, entretenimento, nas principais linguagens `},
            {nome : 'MARKETING DIGITAL', valor: `Serviço que visa alavancar seus negócios com técnicas de venda e análise de negócio`},        
            {nome : 'HOSPEDAGEM', valor: `Oferecemos ambiente de teste em hospedagem paga por nossa conta, para que o usuário faça seus testes`},
            {nome : 'CURSOS VIRTUAIS', valor: `Plataforma de cursos on line , com direito a suporte via zoom,whats app, diretamente com nosso time - SAP, JAVA,.NET,ETC`}
        ]

    },
    produtos:{
        text2: 'Clique para visualizar uma prévia dos sistemas:',
        text3: 'Financeiro',
        text4: 'Médico',
        text5: 'E-commerce',
        text6: 'Logística',
        text7: 'Ifood',
        text8: 'Banco Digital',
        text9:'Locadora',
        text10:'Pet Shop'      
    }

}